export enum EnumProgramMarketingScope {
  NATIONAL = 'NATIONAL',
  AREA = 'AREA',
  SUB_AREA = 'SUB_AREA',
  DISTRIBUTOR = 'DISTRIBUTOR',
  RETAILER = 'RETAILER',
}

export enum EnumProgramMarketingScopeString {
  NATIONAL = 'Nasional',
  AREA = 'Area',
  SUB_AREA = 'Sub Area',
  DISTRIBUTOR = 'Distributor',
  RETAILER = 'Retailer',
}

export enum EnumProgramMarketingType {
  ONE_SHOOT = 'ONE_SHOOT',
  DISCOUNT_PRODUCT = 'DISCOUNT_PRODUCT',
  DISCOUNT_PURCHASE = 'DISCOUNT_PURCHASE',
  PRODUCT_COMPENSATION = 'PRODUCT_COMPENSATION',
}
export enum EnumProgramMarketingTypeString {
  ONE_SHOOT = 'One Shoot',
  DISCOUNT_PRODUCT = 'Diskon Produk',
  DISCOUNT_PURCHASE = 'Diskon dengan Pembelian',
  PRODUCT_COMPENSATION = 'Kompensasi Produk',
}

export enum EnumProgramMarketingStatus {
  SUBMITTED = 'SUBMITTED',
  NEED_CHANGED = 'NEED_CHANGED',
  ACTIVE = 'ACTIVE',
  SCHEDULED = 'SCHEDULED',
  FINISHED = 'FINISHED',
  EXTEND_PERIOD = 'EXTEND_PERIOD',
  REJECTED_EXTEND_PERIOD = 'REJECTED_EXTEND_PERIOD',
}

export enum EnumProgramMarketingStatusString {
  ACTIVE = 'Aktif',
  SUBMITTED = 'Diajukan',
  EXTEND_PERIOD = 'Pengajuan Perpanjangan',
  NEED_CHANGED = 'Butuh Perbaikan',
  SCHEDULED = 'Dijadwalkan',
  FINISHED = 'Selesai'
}

export enum EnumProgramMarketingSection {
  INFORMATION = 'INFORMATION',
  ORDER_TERM = 'ORDER_TERM',
  PROGRAM_TERM = 'PROGRAM_TERM',
  DISCOUNT_TERM = 'DISCOUNT_TERM', // ketentuan diskon
  SCHEMA_PROMOTIONS = 'SCHEMA_PROMOTION',
  COMPENSATION = 'COMPENSATION',
}

export enum EnumVerificationStatus {
  VERIFIED = 'VERIFIED',
  REQUEST_REVISION = 'REQUEST_REVISION',
}

export enum EnumLegacyProgramMarketingDiscount {
  EQUAL_SALES_DISCOUNT = 'EQUAL_SALES_DISCOUNT',
  SET_MAXIMUM_SALES_DISCOUNT = 'SET_MAXIMUM_SALES_DISCOUNT',
  NO_SALES_DISCOUNT = 'NO_SALES_DISCOUNT',
  FIXED_SALES_DISCOUNT = 'FIXED_SALES_DISCOUNT',
}
export enum EnumLegacyProgramMarketingDiscountString {
  EQUAL_SALES_DISCOUNT = 'Normal',
  SET_MAXIMUM_SALES_DISCOUNT = 'Maksimal',
  NO_SALES_DISCOUNT = 'Tanpa Sales Discount',
}

export enum EnumProgramMarketingPOType {
  BUNDLING = 'BUNDLING',
  ACCUMULATION = 'ACCUMULATION',
}

export enum EnumProgramMarketingPOTypeString {
  BUNDLING = 'Bundling',
  ACCUMULATION = 'Akumulasi/Gabungan Produk',
}

export enum EnumProgramMarketingRewardType {
  MAI_PRODUCT = 'PRODUCT_MAI',
  NON_MAI_PRODUCT = 'PRODUCT_NON_MAI',
}

export enum EnumProgramMarketingAccumulationType {
  MINIMUM_WEIGHT_OR_VOLUME = 'MINIMUM_WEIGHT_VOLUME',
  MINIMUM_QTY = 'MINIMUM_QUANTITY',
  MINIMUM_PRICE = 'MINIMUM_PRICE',
}

export enum EnumProgramMarketingQuotaType {
  ALL = 'ALL',
  PER_SCOPE = 'PER_SCOPE',
  UNLIMITED = 'UNLIMITED',
}

export enum EnumProgramMarketingQuotaTypeString {
  ALL = 'Kuota Keseluruhan',
  PER_SCOPE = 'Kuota Per Cakupan',
  UNLIMITED = 'Tanpa Kuota',
}

export enum EnumProgramMarketingDiscountProgramType {
  EQUAL_SALES_DISCOUNT = 'EQUAL_SALES_DISCOUNT',
  SET_MAXIMUM_SALES_DISCOUNT = 'SET_MAXIMUM_SALES_DISCOUNT',
  FIXED_SALES_DISCOUNT = 'FIXED_SALES_DISCOUNT',
  NO_SALES_DISCOUNT = 'NO_SALES_DISCOUNT',
  ONE_SHOOT_DISCOUNT = 'ONE_SHOOT_DISCOUNT',
  AVAILABLE_TO_USE_DISCOUNT_PRODUCT = 'AVAILABLE_TO_USE_DISCOUNT_PRODUCT',
}
export enum EnumProgramMarketingDiscountProgramTypeString {
  ONE_SHOOT_DISCOUNT = 'Memiliki Diskon khusus Program',
  AVAILABLE_TO_USE_DISCOUNT_PRODUCT = 'Mengikuti Program Diskon yang berlaku',
  EQUAL_SALES_DISCOUNT = 'Maksimal Sales Diskon Level 2',
  SET_MAXIMUM_SALES_DISCOUNT = 'Atur Maksimal Diskon',
  FIXED_SALES_DISCOUNT = 'Atur Diskon Fixed',
  NO_SALES_DISCOUNT = 'Tanpa Diskon',
}

export enum EnumProgramMarketingDiscountScope {
  ALL = 'ALL',
  PER_PRODUCT = 'PER_PRODUCT',
}
export enum EnumProgramMarketingDiscountScopeString {
  ALL = 'Keseluruhan Program',
  PER_PRODUCT = 'Per Produk',
}

export enum EnumProgramMarketingSettingDiscount {
  SET_MAXIMUM_SALES_DISCOUNT = 'SET_MAXIMUM_SALES_DISCOUNT',
  FIXED_SALES_DISCOUNT = 'FIXED_SALES_DISCOUNT',
}

export enum EnumProgramMarketingSettingDiscountString {
  SET_MAXIMUM_SALES_DISCOUNT = 'Atur Maksimal Diskon',
  FIXED_SALES_DISCOUNT = 'Atur Diskon Fixed',
}

export enum EnumProgramMarketingDiscountCategory {
  PERCENTAGE = 'PERCENTAGE',
  NOMINAL = 'NOMINAL',
}
export enum EnumProgramMarketingDiscountCategoryString {
  PERCENTAGE = 'Presentase (%)',
  NOMINAL = 'Nominal (Rp)',
}

export enum EnumProgramMarketingDiscountType {
  SET_MAXIMUM_SALES_DISCOUNT = 'SET_MAXIMUM_SALES_DISCOUNT',
  FIXED_SALES_DISCOUNT = 'FIXED_SALES_DISCOUNT',
}
export enum EnumProgramMarketingDiscountTypeString {
  SET_MAXIMUM_SALES_DISCOUNT = 'Jumlah Maksimal',
  FIXED_SALES_DISCOUNT = 'Tetap/Fixed',
}

export enum EnumProgramMarketingOrderUnitType {
  SALE_UNIT = 'SALE_UNIT',
  WEIGHT_UNIT = 'WEIGHT_UNIT',
}
export enum EnumProgramMarketingOrderUnitTypeString {
  SALE_UNIT = 'Satuan Jual (box/jerigen/bag)',
  WEIGHT_UNIT = 'Satuan Berat (L/kg)',
}

export enum EnumProgramMarketingDiscountProgramOneShootType {
  ONE_SHOOT_DISCOUNT = 'ONE_SHOOT_DISCOUNT',
  AVAILABLE_TO_USE_DISCOUNT_PRODUCT = 'AVAILABLE_TO_USE_DISCOUNT_PRODUCT',
  EQUAL_SALES_DISCOUNT = 'EQUAL_SALES_DISCOUNT',
  NO_SALES_DISCOUNT = 'NO_SALES_DISCOUNT',
}

export enum EnumProgramMarketingDiscountProgramOneShootTypeString {
  ONE_SHOOT_DISCOUNT = 'Memiliki Diskon khusus Program',
  AVAILABLE_TO_USE_DISCOUNT_PRODUCT = 'Mengikuti Program Diskon yang berlaku',
  EQUAL_SALES_DISCOUNT = 'Maksimal Sales Diskon Level 2',
  NO_SALES_DISCOUNT = 'Tanpa Diskon',
}

export enum EnumInclusionProgramTermType {
  INCLUDE_ALL = 'INCLUDE_ALL',
  EXCLUDE_ALL = 'EXCLUDE_ALL',
  EXCLUDE_PARTIAL = 'EXCLUDE_PARTIAL',
}

export enum EnumInclusionProgramTermTypeString {
  INCLUDE_ALL = 'Termasuk Hitungan',
  EXCLUDE_ALL = 'Dikecualikan dari Semua Program',
  EXCLUDE_PARTIAL = 'Sebagian Program Dikecualikan',
}

export enum EnumInclusionProgramTermDistributorString {
  INCLUDE_ALL = 'Produk dari program ini akan dimasukkan perhitungan seluruh Program Long Term yang Dijadwalkan dan Aktif',
  EXCLUDE_ALL = 'Produk dari program ini tidak akan dimasukkan ke dalam seluruh perhitungan Program Long Term',
  EXCLUDE_PARTIAL = 'Produk dari program ini tidak akan dimasukkan ke perhitungan Program Long Term yang dipilih',
}

export enum EnumInclusionProgramTermRetailerString {
  INCLUDE_ALL = 'Produk dari program ini akan dimasukkan perhitungan seluruh Program Retailer yang Dijadwalkan dan Aktif',
  EXCLUDE_ALL = 'Produk dari program ini tidak akan dimasukkan ke dalam seluruh perhitungan Program Retailer',
  EXCLUDE_PARTIAL = 'Produk dari program ini tidak akan dimasukkan ke perhitungan Program Retailer yang dipilih',
}

export enum EnumRewardOptionType {
  FIXED_PRODUCT = 'FIXED_PRODUCT',
  SAME_AS_PURCHASED = 'SAME_AS_PURCHASED',
}

export enum EnumRewardSelectionType {
  PARTIAL_SELECTION = 'PARTIAL_SELECTION',
  ALL_REQUIRED = 'ALL_REQUIRED',
}

export enum EnumDiscountScopeType {
  ALL = 'ALL',
  PER_PRODUCT = 'PER_PRODUCT',
}

export enum EnumDiscountScopeString {
  ALL = 'Keseluruhan produk di Program',
  PER_PRODUCT = 'Per Produk',
}

// export enum EnumLevelDiscountType {
//   LEVEL_1 = 'LEVEL_1',
//   LEVEL_2 = 'LEVEL_2',
//   LEVEL_3 = 'LEVEL_3',
//   LEVEL_4 = 'LEVEL_4',
//   LEVEL_5 = 'LEVEL_5',
//   LEVEL_6 = 'LEVEL_6',
//   LEVEL_7 = 'LEVEL_7',
//   LEVEL_8 = 'LEVEL_8',
//   LEVEL_9 = 'LEVEL_9',
//   LEVEL_10 = 'LEVEL_10',
// }

export enum EnumLevelDiscountString {
  LEVEL_1 = 'Tingkat 1',
  LEVEL_2 = 'Tingkat 2',
  LEVEL_3 = 'Tingkat 3',
  LEVEL_4 = 'Tingkat 4',
  LEVEL_5 = 'Tingkat 5',
  LEVEL_6 = 'Tingkat 6',
  LEVEL_7 = 'Tingkat 7',
  LEVEL_8 = 'Tingkat 8',
  LEVEL_9 = 'Tingkat 9',
  LEVEL_10 = 'Tingkat 10',
}

export enum EnumStatusEditedLog {
  ADD = 'ADD',
  UPDATED = 'UPDATED',
  NOT_CHANGE = 'NOT_CHANGE',
  DELETE = 'DELETE',
}
